// extracted by mini-css-extract-plugin
module.exports = {"loadingScrim":"loading-scrim_component_loadingScrim__agJn_","spin":"loading-scrim_component_spin__dWJL9"};